/** String Consts for MPR tools */

export const LEVEL_TOOL = "LEVEL";
export const LENGTH_TOOL = "LENGTH";
export const ERASER_TOOL = "ERASER";
export const SELECT_TOOL = "SELECT";

export const BLEND_NONE = "none";
export const BLEND_MIP = "MIP";
export const BLEND_MINIP = "MINIP";
export const BLEND_AVG = "AVG";

export const FRONT = "front";
export const TOP = "top";
export const LEFT = "left";

export const ACTIONS = {
  level: LEVEL_TOOL,
  crosshair: SELECT_TOOL
};

export default {
  LEVEL_TOOL,
  SELECT_TOOL,
  LENGTH_TOOL,
  ERASER_TOOL,
  BLEND_AVG,
  BLEND_MINIP,
  BLEND_MIP,
  BLEND_NONE,
  FRONT,
  TOP,
  LEFT
};
